// extracted by mini-css-extract-plugin
export default {"headline":"LinkFacebookAccount--headline--zZjK2"};